import React from 'react'
import {
  Actions,
  InfoLink,
  MainSection,
  TD,
  TR
} from './styles'

interface Props {
  id: number
  data: any[]
  hoverData: any[]
  actionBlock: any
  index: number
  lastItemNumber: number
  goTo?: (id: string | number, isNew: boolean) => string;
} // to={`/estimate/${id}/${isNew}`}
const isNew = false
const ListItem: React.FC<Props> = ({
  id,
  data,
  hoverData,
  actionBlock,
  index,
  lastItemNumber,
  goTo
}) => (
    <>
    {goTo ?
        // If there is any route to go to
        (<TR isLast={lastItemNumber === index}>
        <InfoLink
            to={goTo(id, isNew)}
        >
            <MainSection>
            {data.map((item, i) => (
                <TD key={i}>{item}</TD>
            ))}
            </MainSection>
        </InfoLink>
        {actionBlock && actionBlock() && <Actions>{actionBlock(id)}</Actions>}
        </TR>)
        : // If there is no route to go to
        (<TR isLast={lastItemNumber === index}>
            <MainSection>
                {data.map((item, i) => (
                <TD key={i}>{item}</TD>
                ))}
            </MainSection>
            {actionBlock && actionBlock() && <Actions>{actionBlock(id)}</Actions>}
        </TR>)
    }
    </>
)

export default ListItem
